function AudioPlayerCardPlusIcon() {
  return (
    <svg
      aria-hidden="true"
      className="size-6 shrink-0"
      fill="currentColor"
      viewBox="0 0 24 24"
    >
      <path d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12.25 6.5C12.8023 6.5 13.25 6.94772 13.25 7.5V11.25H17C17.5523 11.25 18 11.6977 18 12.25C18 12.8023 17.5523 13.25 17 13.25H13.25V17C13.25 17.5523 12.8023 18 12.25 18C11.6977 18 11.25 17.5523 11.25 17V13.25H7.5C6.94771 13.25 6.5 12.8023 6.5 12.25C6.5 11.6977 6.94771 11.25 7.5 11.25H11.25V7.5C11.25 6.94772 11.6977 6.5 12.25 6.5Z" />
    </svg>
  );
}

export { AudioPlayerCardPlusIcon };
